import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ZoomOutMapIcon(props: IconProps) {
    return <Icon {...props} iconKey={"zoom_out_map"}/>
}
